import { Button } from '@heroui/react'
import { RadioGroup } from '@heroui/react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Header from '@/components/public/Header'
import CustomRadio from '@/components/account/CustomRadio'
import { ArrowRight } from 'lucide-react'
import { PROFILE_OPTIONS, PROFILE_ROUTE_MAP } from '@/constants/profiles'

export default function PublicIndex() {
	const [selected, setSelected] = useState<string | null>(null)
	const nav = useNavigate()

	const handleContinue = () => {
		if (!selected) return
		const route = PROFILE_ROUTE_MAP[selected]
		if (route) nav(route)
	}

	return (
		<div className="flex flex-col items-center justify-center bg-black">
			<Header description="Welcome to Leangap!" subDescription="Select the appropriate option" />
			<form
				className="mx-auto w-full max-w-lg space-y-6"
				onSubmit={(e) => {
					e.preventDefault()
					handleContinue()
				}}
			>
				<div className="flex flex-col gap-2">
					<label className="text-default-500 block font-medium">
						I'm a...<span className="text-danger-500">*</span>
					</label>
					<RadioGroup
						value={selected}
						onValueChange={setSelected}
						description=" Selected profile can't be changed after sign up."
					>
						{PROFILE_OPTIONS.map((opt) => (
							<CustomRadio key={opt.label} value={opt.label} description={opt.desc}>
								{opt.label}
							</CustomRadio>
						))}
					</RadioGroup>
				</div>
				<Button
					type="submit"
					color="primary"
					className="mt-6 w-full"
					isDisabled={!selected}
					size="lg"
				>
					Continue <ArrowRight className="size-5" />
				</Button>
			</form>
		</div>
	)
}
